import type * as types from './types';
import { mockCarrierRateCalculationResponse } from '../CarrierService/fixtures';
import type { ShiptimeLtlCostResponse } from '@shipium-corp/shipium-ts-types';
// typeHack allows creating the data I need for testing
// new shipment component without creating mocked full response
const typeHack: any = {};
export const mockShipmentResponse: types.Shipment = {
  shipiumShipmentId: '4692806d-bf74-413b-950e-1351d7772935',
  orderedDateTime: '2021-01-13T22:07:58.554Z',
  shippedDateTime: '2021-01-13T00:00:00Z',
  // deliveredDateTime: null,
  // carrierName: null,
  // carrierTrackingId: null,
  multiParcel: false,
  fulfillmentContextId: 'fcontextid',
  orderItemQuantities: [
    {
      productId: '123456',
      quantity: 1,
      productDetails: [],
    },
  ],
  carrierLabel: {
    ...typeHack,
    trackingInfo: {
      carrier: 'ups',
      trackingId: '12312312-dqd2',
      shippedDateTime: '2021-06-08T03:12:04Z',
      deliveredDateTime: '2021-06-10T02:09:55Z',
      currentStatus: {
        deliveryStep: 'Delivered',
        shipmentStatus: 'Delivered',
        statusMessage: 'Delivered',
        eventDateTime: '2021-06-10T02:09:55Z',
        eventCity: 'SEATTLE',
        eventRegion: 'WA',
        eventPostalCode: '98103',
        eventCountry: 'US',
      },
      events: [
        {
          deliveryStep: 'Delivered',
          shipmentStatus: 'Delivered',
          statusMessage: 'Delivered',
          eventDateTime: '2021-06-10T02:09:55Z',
          eventCity: 'SEATTLE',
          eventRegion: 'WA',
          eventPostalCode: '98103',
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'InTransit',
          statusMessage: 'Out For Delivery Today',
          eventDateTime: '2021-06-09T22:42:17Z',
          eventCity: 'Seattle',
          eventRegion: 'WA',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'InTransit',
          statusMessage: 'Loaded on Delivery Vehicle',
          eventDateTime: '2021-06-09T18:56:24Z',
          eventCity: 'Seattle',
          eventRegion: 'WA',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'InTransit',
          statusMessage: 'Processing at UPS Facility',
          eventDateTime: '2021-06-09T18:46:17Z',
          eventCity: 'Seattle',
          eventRegion: 'WA',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'InTransit',
          statusMessage: 'Arrived at Facility',
          eventDateTime: '2021-06-09T16:06:00Z',
          eventCity: 'Seattle',
          eventRegion: 'WA',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'InTransit',
          statusMessage: 'Departed from Facility',
          eventDateTime: '2021-06-09T12:35:00Z',
          eventCity: 'Portland',
          eventRegion: 'OR',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'InTransit',
          statusMessage: 'Origin Scan',
          eventDateTime: '2021-06-09T09:17:13Z',
          eventCity: 'Portland',
          eventRegion: 'OR',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'PickedUp',
          statusMessage: 'Pickup Scan',
          eventDateTime: '2021-06-09T01:18:15Z',
          eventCity: 'Portland',
          eventRegion: 'OR',
          eventPostalCode: null,
          eventCountry: 'US',
        },
        {
          deliveryStep: 'InTransit',
          shipmentStatus: 'PickedUp',
          statusMessage: 'Shipper created a label, UPS has not received the package yet.',
          eventDateTime: '2021-06-08T03:12:04Z',
          eventCity: null,
          eventRegion: null,
          eventPostalCode: null,
          eventCountry: 'US',
        },
      ],
    },
  },
  destinationAddress: {
    name: 'Scott Puleo',
    phoneNumber: '16314131830',
    company: 'Scott Puleo',
    street1: '8100 Barthrop Pl NE',
    street2: 'Barthrop Pl',
    city: 'Bainbridge Island',
    state: 'WA',
    countryCode: 'US',
    postalCode: '98110',
    addressType: 'residential',
  },
  shipOption: 'Standard',
  shipFromAddress: {
    name: 'NA',
    phoneNumber: '2062652733',
    company: 'Just Great Cables',
    street1: '5003 Premier Pkwy',
    city: 'St Peters',
    state: 'MO',
    countryCode: 'US',
    postalCode: '63376',
    addressType: 'commercial',
  },
  fulfillmentCenterId: '4b9dfbfa-c6d0-42dd-97bd-413b2e6b20b2',
  packagingType: {
    packagingMaterial: 'box',
    packagingSizeName: 'test-package',
    packagingTypeId: null,
    linearDimensions: {
      height: 1,
      length: 12,
      linearUnit: 'in',
      width: 1,
    },
    packagingWeight: {
      weight: 12,
      weightUnit: 'lb',
    },
  },
  totalWeight: {
    weight: 12,
    weightUnit: 'lb',
  },
  shipmentTags: [],
  carrierSelection: {
    status: 'success',
    partnerId: '76abb3d4-8990-4f80-aa13-4c2007cb852a',
    carrierAccountId: '1ffff286-d0cb-4ae6-9a6c-6534c79d5182',
    serviceMethodUrn:
      '76abb3d4-8990-4f80-aa13-4c2007cb852a:1ffff286-d0cb-4ae6-9a6c-6534c79d5182:1:3e7a801a-e95e-4809-ae00-e08b0b1b321f:1',
    carrier: 'ups',
    serviceMethodName: 'UPS Ground Res',
    totalCost: 9.76,
    ...mockCarrierRateCalculationResponse,
  },
};

export const mockLtlCostResponse: ShiptimeLtlCostResponse = {
  shipiumLtlCostId: 'ltl-test-id',
  shipFromAddress: {
    countryCode: 'US',
    postalCode: '98101',
  },
  destinationAddress: {
    countryCode: 'US',
    postalCode: '98102',
  },
  recommendedTransportationType: 'ltlTransportation',
  recommendedTransportationTypeCost: 100,
  testMode: true,
  units: {
    currencyCode: 'USD',
    weightUnit: 'lb',
    linearUnit: 'in',
  },
  allTransportationTypeCosts: [
    {
      transportationType: 'ltlTransportation',
      transportationTypeCost: 100,
    },
    {
      transportationType: 'packageTransportation',
      transportationTypeCost: 200,
    },
  ],
  ltlCostDetails: {
    loadPackaging: [
      {
        details: {
          loadPackagingSize: {
            height: 10,
            length: 10,
            width: 10,
            weight: 10,
          },
          nmfcFreightClass: `50`,
        },
      },
    ],
  },
  ltlShipmentParameters: {
    paymentDetails: {
      payerType: 'thirdParty',
      paymentTerms: 'prePaid',
    },
    pickupDate: '2021-07-15T00:00:00+00:00',
  },
};
